// extracted by mini-css-extract-plugin
export default {"title":"FrequencyBlock_title__xg-tb","groupHeader":"FrequencyBlock_groupHeader__BFaom","groupName":"FrequencyBlock_groupName__1ialY","collapse":"FrequencyBlock_collapse__Fembh"};